import { FC, useMemo } from 'react';
import { ExportOutlined } from '@ant-design/icons';
import { USDTWithdrawalCountChartProps } from '../../../../../../core/domain/overview/usdt-withdrawal-count';
import { ChartCard } from '../../components/chart-card/chart-card';
import { BarSeriesChart, CHART_COLORS, faNumber, mergeByDate, sumOf } from '../chart-commons';

interface Props {
    chartData: USDTWithdrawalCountChartProps;
    chartLoading: boolean;
}

const series = [{ key: 'value', name: 'برداشت', color: CHART_COLORS.green }];

export const USDTWithdrawalCount: FC<Props> = ({ chartData, chartLoading }) => {
    const data = useMemo(() => mergeByDate([{ key: 'value', data: chartData?.withdrawalUsdtChart }]), [chartData]);

    return (
        <ChartCard
            title="تعداد برداشت های تتر"
            subtitle="روند برداشت‌های تتر کاربران"
            icon={<ExportOutlined />}
            accent="green"
            loading={chartLoading}
            empty={!data.length}
            stats={[{ label: 'مجموع بازه', value: faNumber(sumOf(data, 'value')), color: CHART_COLORS.green }]}
        >
            <BarSeriesChart data={data} series={series} />
        </ChartCard>
    );
};
